import { Customer } from "./customer";
import { Policy } from "./policy";

export class AmendPolicy extends Policy {
    amendmentVersionCode!: string;

    constructor(data?: any) {
        super();

        if (data) {

          this.amendmentVersionCode=data.amendmentVersionCode;
          this.id = data.id;

          this.productName = data.productName;
          this.productCategoryCode = data.productCategoryCode;
          this.productCategoryId = data.productCategoryId;
          this.productCategoryName = data.productCategoryName;
          this.productVersion = data.productVersion;
          this.productVersionCode = data.productVersionCode;

          this.uniqueIdentifier = data.uniqueIdentifier;
          this.policyNumber = data.policyNumber;
          this.contractNumber = data.contractNumber;
          this.insuranceHolderCodeId = data.insuranceHolderCodeId;
          this.insuranceGroupCodeId = data.insuranceGroupCodeId;
          this.brokerCodeId = data.brokerCodeId;
          this.insuranceHolderFullName = data.insuranceHolderFullName;

          this.productTypeId = data.productTypeId;
          this.validFromDate = new Date(data.validFromDate);
          this.validToDate = new Date(data.validToDate);
          this.activationDate = new Date(data.activationDate);

          this.grossPrice = data.grossPrice;
          this.discountAmount = data.discountAmount;
          this.discountPercentage = data.discountPercentage;

          this.statusId = data.statusId;
          this.subStatusId = data.subStatusId;
          this.isSensitive = data.isSensitive;
          this.isArchived = data.isArchived;
          this.summary = data.summary;

          this.branchId = data.branchId;
          this.createdAt = new Date(data.createdAt);

          this.brokerName = data.brokerName;
          this.createdByUserName = data.createdByUserName;
          this.status = data.status;
          this.subStatus = data.substatus;
          this.customer = new Customer(); // TODO: CHECK IS THIS GOOD
          this.isRequiredForAmendment = data.isRequiredForAmendment;

          this.numberOfInstallments = data.numberOfInstallments;
          this.policyDetails=data.policyDetails;
          this.policyCalculationDetails=data.policyCalculationDetails;
        }
      }
}